import { RouteConfig } from "vue-router";

export const REmployerHomeNew: RouteConfig = {
  path: "home",
  name: "EmployerHomeNew",
  component: () =>
    import(
      /* webpackChunkName: "employee-home" */
      "./VEmployerHome.vue"
    ),
  meta: {
    title: "Home",
    pageTitile: "Welcome to Nation.better!",
    icon: "grid-outline",
    newIcon: "home",
    version: 2,
  },
};
